export default {
    methods: {
        getHeadersTabella() {
            return [
                { text: "Codice utente", value: "companyCode", sortable: false },
                { text: "Ragione Sociale", value: "ragioneSociale", sortable: false },
                { text: "Gruppo", value: "gruppo", sortable: false },
                { text: "Certificazione", value: "", sortable: false },
                { text: "Audit FSC", value: "", sortable: false },
                { text: "Audit FSC Gruppo", value: "", sortable: false },
                { text: "Audit FPC", value: "", sortable: false },
                { text: "Audit ISO", value: "", sortable: false },
                { text: "Audit PEFC", value: "", sortable: false },
                { text: "Audit PEFC Gruppo", value: "", sortable: false },
                { text: "Stato", value: "enabled", sortable: false },
                { text: "Azioni", value: "", sortable: false },
            ]
        },

        getDimensioneColonne() {
            return [
                { wch: 25 },
                { wch: 50 },
                { wch: 30 },
                { wch: 40 },
                { wch: 20 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 100 },
                { wch: 10 },
                { wch: 10 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
            ]
        }
    }
}